import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCopy } from '@fortawesome/pro-light-svg-icons';

export type ProLightCopyProps = IconComponentProps;

export const ProLightCopy = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCopyProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCopy}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCopy}
    />
  );
};

ProLightCopy.displayName = 'ProLightCopy';
